import { tectonFeatureOutletObservedAttrs, tectonFeatureOutlet } from './feature-outlet';
import { tectonTabbedOutletObservedAttrs, TectonTabbedOutlet } from './tabbed-outlet';
import { setupTectonElement } from 'q2-tecton-common/lib/outlets/tecton-outlet-base';
import { IMessageBus } from 'q2-tecton-common/lib/utility/message-bus';
import { ITranslationSetup } from '../t';

export default function setupQ2Outlets(
    messageBus: IMessageBus,
    moduleId: string,
    loc: ITranslationSetup['tFn']
): void {
    setupTectonElement({
        messageBus,
        moduleId,
        props: tectonFeatureOutletObservedAttrs,
        tectonOutletAdaptor: tectonFeatureOutlet
    })('tecton-outlet');

    setupTectonElement({
        messageBus,
        moduleId,
        props: tectonTabbedOutletObservedAttrs,
        tectonOutletAdaptor: TectonTabbedOutlet(loc)
    })('tecton-tabbed-outlet');
}
